import React from 'react';
import styled from 'styled-components';
import { useAuth0 } from '@auth0/auth0-react';
import { useHistory } from 'react-router-dom';
import Loading from '../Loading';

const StyledCallback = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
`;

const Callback = () => {
  const { isAuthenticated, isLoading, error } = useAuth0();
  const history = useHistory();

  React.useEffect(() => {
    if (isAuthenticated && !isLoading) {
      // Redirect to home or the returnTo path from appState
      const returnTo = history.location.state?.appState?.returnTo || '/';
      history.replace(returnTo);
    }
  }, [isAuthenticated, isLoading, history]);

  if (error) {
    return (
      <StyledCallback>
        <div>
          <h1>Authentication Error</h1>
          <p>{error.message}</p>
        </div>
      </StyledCallback>
    );
  }

  return (
    <StyledCallback>
      <Loading />
    </StyledCallback>
  );
};

export default Callback;
